import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import './index.css';
import { toast } from 'react-toastify';

const UserDeletion = () => {
  const [email, setEmail] = useState('');
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);

  useEffect(() => {
    // Store original geolocation object
    const originalGeolocation = navigator.geolocation;
    
    // Override geolocation to prevent location requests
    Object.defineProperty(navigator, 'geolocation', {
      value: {
        getCurrentPosition: () => {
        },
        watchPosition: () => {
          return 0;
        },
        clearWatch: () => {}
      },
      configurable: true
    });

    // Disable Google Maps location services if present
    let originalLatLng: any = null;
    if (window.google && window.google.maps) {
      // Store original LatLng constructor
      originalLatLng = window.google.maps.LatLng;
      
      // Override to prevent new location requests
      (window.google.maps.LatLng as any) = function(...args: any[]) {
        return new originalLatLng(...args);
      };
    }

    // Clear any existing location watchers
    const clearLocationWatchers = () => {
      // Clear any intervals that might be requesting location
      for (let i = 1; i < 99999; i++) {
        window.clearInterval(i);
      }
      
      // Clear any timeouts that might be requesting location
      for (let i = 1; i < 99999; i++) {
        window.clearTimeout(i);
      }
    };

    clearLocationWatchers();

    // Cleanup on unmount
    return () => {
      // Restore original geolocation
      Object.defineProperty(navigator, 'geolocation', {
        value: originalGeolocation,
        configurable: true
      });
      
      // Restore original Google Maps LatLng if it was overridden
      if (originalLatLng && window.google && window.google.maps) {
        window.google.maps.LatLng = originalLatLng;
      }
    };
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !isConfirmed) {
      toast.warning('Please fill in all required fields and confirm your understanding.');
      return;
    }
    // Handle account deletion logic here
    
    // Simulate successful deletion
    setTimeout(() => {
      setIsDeleted(true);
    }, 1000);
  };

  const handleDone = () => {
    // Redirect to home page or login page
    window.location.href = '/';
  };

  // Show success message if account is deleted
  if (isDeleted) {
    return (
      <Container className="user-deletion-container p-4">
        <Row className="justify-content-center">
          <Col lg={8} md={10}>
            <div className="deletion-card">
              <div className="success-content">
                <h1 className="success-title">Thank you for using our service!</h1>
                <p className="success-message">
                  We are sorry to see you go, but we respect your decision to delete your account. Your account deletion request has been 
                  successfully. If you ever decided to return, we will be here with new updates and features to make your experience even better.
                </p>
                <div className="d-grid">
                  <Button
                    onClick={handleDone}
                    className="done-button"
                  >
                    DONE
                  </Button>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container className="user-deletion-container p-4">
      <Row className="justify-content-center">
        <Col lg={8} md={10}>
        <div className="deletion-card">
            <h1 className="deletion-title">Delete Account & Data</h1>
            <p className="deletion-warning-text">
              This action will permanently erase your profile, history, and all associated data. This cannot be undone.
            </p>
            <Alert variant="danger" className="deletion-alert">
              <Alert.Heading as="h6">
                ⚠️ Deleting your account will remove access to all services, subscriptions, and stored files.
              </Alert.Heading>
            </Alert>

            <div className="deletion-info">
              <p className="info-text">By clicking 'Delete My Account', I acknowledge that:</p>
              
              <ul className="deletion-points">
                <li>All my personal data, including profile, messages, history, will be permanently erased.</li>
                <li>This action cannot be undone, and I may lose access to services immediately.</li>
                <li>Active subscriptions won't auto-cancel (visit Subscriptions) first.</li>
                <li>Some anonymized data may remain in backups for (30 days) per legal requirements.</li>
              </ul>
            </div>

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  id="confirmation-checkbox"
                  label="I understand the consequences and wish to proceed"
                  checked={isConfirmed}
                  onChange={(e) => setIsConfirmed(e.target.checked)}
                  className="confirmation-checkbox"
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label className="email-label">To confirm enter your email:</Form.Label>
                <Form.Control
                  type="email"
                  placeholder=""
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="email-input"
                  required
                />
              </Form.Group>

              <div className="d-grid">
                <Button
                  type="submit"
                  className="delete-button"
                  disabled={!email || !isConfirmed}
                >
                  DELETE ACCOUNT & DATA ↗
                </Button>
              </div>
            </Form>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default UserDeletion;